module.exports = __webpack_public_path__ + "media/12.40be69c4.wav";